<template>
  <v-sheet class="filter-card">
    <span class="filter-card-label">{{ label }}</span>
    <v-select
      v-model="selectedValues"
      :items="filteredOptions"
      multiple
      variant="outlined"
      hide-details
      class="minimal-select"
      :item-title="itemTitle"
      :item-value="itemValue"
      density="compact"
    >
      <!-- Sticky "Select All" and "Clear All" -->
      <template #prepend-item>
        <div class="sticky-header">
          <v-text-field
            v-model="searchQuery"
            placeholder="Search..."
            clearable
            hide-details
            density="compact"
            variant="solo"
            class="search-box"
          />
          <div class="d-flex justify-space-between px-4 pb-2">
            <span @click="selectAll" class="text-primary cursor-pointer">Select All</span>
            <span @click="clearAll" class="text-error cursor-pointer">Clear All</span>
          </div>
          <v-divider />
        </div>
      </template>

      <!-- Minimal Selected Display -->
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index < 1" size="small" class="mr-1">
          {{ getLabel(item) }}
        </v-chip>
        <span v-if="index === 1" class="text-caption text-grey">
          (+{{ selectedValues.length - 1 }} more)
        </span>
      </template>

      <!-- Checkbox Styling for Options -->
      <template #item="{ item, props }">
        <v-list-item v-bind="props">
          <template #prepend>
            <v-checkbox
              :model-value="selectedValues.includes(item.value)"
              @update:model-value="() => toggleSelection(item.value)"
              hide-details
              density="compact"
            />
          </template>
          <!-- <v-list-item-title>{{ item.title }}</v-list-item-title> -->
        </v-list-item>
      </template>
    </v-select>
  </v-sheet>
</template>

<script>
export default {
  props: {
    itemTitle: {
      type: String,
      default: "title",
    },
    itemValue: {
      type: String,
      default: "value",
    },
    label: {
      type: String,
      default: "Select Items",
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    sort: {
      type: String,
      default: "",
    },
    order: {
      type: String,
      default: "asc",
      validator: (value) => ["asc", "desc"].includes(value),
    },
  },
  data() {
    return {
      selectedValues: [...this.modelValue],
      searchQuery: "",
    };
  },
  computed: {
    formattedOptions() {
      const uniqueOptions = new Map();
      this.options.forEach((opt) => {
        if (!uniqueOptions.has(opt.value)) {
          uniqueOptions.set(opt.value, {
            title: opt.label,
            value: opt.value,
          });
        }
      });
      return Array.from(uniqueOptions.values());
    },
    sortedOptions() {
      if (!this.sort) return this.formattedOptions;
      return [...this.formattedOptions].sort((a, b) => {
        if (a[this.sort] < b[this.sort]) return this.order === "asc" ? -1 : 1;
        if (a[this.sort] > b[this.sort]) return this.order === "asc" ? 1 : -1;
        return 0;
      });
    },
    filteredOptions() {
      return this.sortedOptions.filter((opt) =>
        (opt?.title || "").toLowerCase().includes((this.searchQuery || "").toLowerCase())
      );
    },
  },
  watch: {
    modelValue(newVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(this.selectedValues)) {
        this.selectedValues = [...newVal];
      }
    },
    selectedValues(newVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(this.modelValue)) {
        this.$emit("update:modelValue", newVal);
      }
    },
  },
  methods: {
    toggleSelection(value) {
  const index = this.selectedValues.indexOf(value);
  if (index > -1) {
    this.selectedValues = this.selectedValues.filter((v) => v !== value);
  } else {
    this.selectedValues = [...this.selectedValues, value];
  }
},
    selectAll() {
      this.selectedValues = this.filteredOptions.map((item) => item.value);
    },
    clearAll() {
      this.selectedValues = [];
    },
    getLabel(value) {
      const found = this.formattedOptions.find(
        (opt) => opt.value === value || opt.value === value?.value
      );
      return found?.title || value;
    },
  },
};
</script>

<style scoped>
.minimal-select {
  max-width: 400px;
}
.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}
.cursor-pointer {
  cursor: pointer;
}
.search-box {
  background-color: #f5f5f5 !important;
  border-radius: 8px;
}
</style>
